
class Slider {
    constructor() {
        this.mainSlider = jQuery('.slider-main').bxSlider({
            pager : false,
            hideControlOnEnd: true,
            infiniteLoop: false,
        });
        jQuery('.header-carousel').bxSlider({
            slideMargin : 10,
            maxSlides: 6,
            auto: true,
            infiniteLoop: false,
            pause: $('.header-carousel').data('duration'),
            pager : false,
            touchEnabled: false
        })
        jQuery('.main-carousel').bxSlider({
            slideMargin : 10,
            maxSlides: 6,
            auto: true,
            infiniteLoop: false,
            tickerHover: true,
            pause: $('.main-carousel').data('duration'),
        });
        jQuery('.slider-thumbs').bxSlider({
            slideWidth : 200,
            maxSlides: 6,
            infiniteLoop: false,
            pager : false,
            slideMargin : 10,
            hideControlOnEnd: true,
            onSlideNext : function($slideElement, oldIndex, newIndex) {

            }
        });
        jQuery('.slider-thumbs').find('.slide').on('click', (event) => {
            let index = jQuery(event.currentTarget).data('index');
            this.mainSlider.goToSlide(index -1);
        })
    }f
}

export default Slider;